import React from "react";
import { useLocation } from "react-router-dom";
import BgpTabs from "../components/Tabs/BGP/BgpTabs";
import InstancesTabs from "../components/Tabs/Instances/InstancesTabs";
import L3OverviewTabs from "../components/Tabs/L3Overview/L3OverviewTabs";
import AddServiceTabs from "../components/Tabs/AddService/AddService";
import PortDetailsTabs from "../components/Tabs/PortDetails/PortDetails";
import { useAppSelector } from "@redux/hooks";
import { RootState } from "@redux/store/store";
import OutagesTabs from "../components/Tabs/Outages/Outages";
import ConnectionDetailsTabs from "../components/Tabs/ConnectionDetails/ConnectionDetails";
import ReflectorsTabs from "../components/Tabs/ReflectorV2/Reflectors/ReflectorsTabs";
import CloudDetailsTabs from "../components/Tabs/CloudDetails/CloudDetails";
import DatacenterDetailsTabs from "../components/Tabs/DatacenterDetails/DatacenterDetails";

export default function RenderTabsByRoute() {
    const currentStep = useAppSelector((state: RootState) => state.order.currentStep);
    const location = useLocation();
    const isInstancesRoute =
        location.pathname.startsWith("/reflector/management/instances/licensed") ||
        location.pathname.startsWith("/reflector/management/instances/unlicensed") ||
        location.pathname.startsWith("/reflector/management/instances/highavailability") ||
        location.pathname.startsWith("/reflector/management/instances/healthcheck") ||
        location.pathname.startsWith("/reflector/management/instances/syslog");

    return (
        <>
            {location.pathname.startsWith("/kontrol/add-port") &&  currentStep === 4 &&(
                <AddServiceTabs />
            )}
            {location.pathname === "/kontrol/port-details" && <PortDetailsTabs />}
            {location.pathname === "/kontrol/internet/internet-details" && <ConnectionDetailsTabs />}
            {location.pathname === "/kontrol/cloud-connectivity/details" && <CloudDetailsTabs />}
            {location.pathname === "/kontrol/datacenter-details" && <DatacenterDetailsTabs />}
            {location.pathname === "/kontrol/outages" && <OutagesTabs />}

            {location.pathname === "/reflector/management/bgp/neighbors" && <BgpTabs />}
            {location.pathname === "/reflector/management/bgp/status" && <BgpTabs />}

            {location.pathname.startsWith("/reflector/l3overview") && <L3OverviewTabs />}

            {isInstancesRoute && <InstancesTabs />}

            {/* Device/Cluster View Tabs for both bgp-reflectors and clusters routes (header only) */}
            {(
                location.pathname === "/reflector-v2/management/bgp-reflectors" ||
                location.pathname === "/reflector-v2/management/clusters" ||
                location.pathname === "/reflector-v2/management/licensing" ||
                location.pathname === "/reflector-v2/management/licensing/payg"
            ) && <ReflectorsTabs />}

        </>
    );
}
